import { Users, Globe, Database } from "lucide-react";
import { StatCard } from "../../common";

export const StatsOverviewGrid = ({ displayStats, selectedYear, sparklines }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    <StatCard
      title="Total Apps Tracked"
      value={displayStats.total?.toLocaleString?.() ?? displayStats.total}
      icon={Database}
      subtitle={selectedYear ? `In ${selectedYear}` : "Since ChatGPT launch"}
      color="primary"
      sparkline={sparklines?.total}
      description="Every AI-powered application we've identified across app stores, web directories, Product Hunt, HuggingFace, and other sources, spanning tools, platforms, and services that use artificial intelligence as a core capability."
    />
    <StatCard
      title="Care-Centered"
      value={(displayStats.orientation?.care || 0).toLocaleString()}
      icon={Users}
      subtitle="Health, education, wellbeing"
      color="care"
      sparkline={sparklines?.care}
      description="Apps oriented toward human wellbeing: healthcare, mental health, education, accessibility, elder care, and community support. These prioritize social benefit over extraction, using AI to uplift rather than exploit."
    />
    <StatCard
      title="Female-Founded"
      value={(displayStats.founders?.female_only || 0).toLocaleString()}
      icon={Users}
      subtitle="Female-only teams"
      color="female_only"
      sparkline={sparklines?.female}
      description="AI apps built by all-female founding teams. Tracking founder gender helps reveal who is shaping AI's future and whether diverse perspectives are represented in the innovation ecosystem."
    />
    <StatCard
      title="Countries"
      value={displayStats.num_countries}
      icon={Globe}
      subtitle="Geographic spread"
      color="creative"
      description="The number of distinct countries where AI apps originate. A wider geographic spread signals that AI innovation is becoming global rather than concentrated in a few tech hubs."
    />
  </div>
);

export default StatsOverviewGrid;
